import React, { Component } from 'react'
import "./OrderList.less";
import { appMethod as app } from '@utils/app';
import { Toast } from 'antd-mobile';

export default class OrderList extends Component {
  state = {
    tabStatus: '1',
    list: [],
    isMore: '',
    currentPage: 1,
    isNeedVip: false,
    isNeedIntegral: false,
  }
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    if (app.isLogin()) {
      Promise.all([this.getVipInfo(),this.getIntegralInfo()]).then(() => {
        if(!this.state.isNeedVip && this.state.isNeedIntegral){
          this.setState({
            tabStatus: '2',
          })
          this.getMessageData('2');
        }else {
          this.setState({
            tabStatus: '1',
          })
          this.getMessageData('1');
        }
      })
      
    }else{
      app.turnToPage('login-pc');
    }
  }
  getVipInfo = () => {
    let that = this;
    return new Promise(resolve => {
      app.sendRequest({
        url: '/index.php?r=appVipCard/getUserAccountSurvey',
        data: {
          app_id: app.getAppId(),
          card_type: 2
        },
        hideLoading: true,
        success: (res) => {
          if(res.status == 0){
            that.setState({
              isNeedVip: Boolean(res.data.all_vip_card.length),
            })
            resolve();
          }
        }
      })
    })
  }
  getIntegralInfo = () => {
    let that = this;
    return new Promise(resolve => {
      app.sendRequest({
        url: '/index.php?r=ChatAI/GetChatIntegralConfigList',
        hideLoading: true,
        data: {
          app_id: app.getAppId(),
          card_type: 2
        },
        success: (res) => {
          if(res.status != 0){return}
          that.setState({
            isNeedIntegral: Boolean(res.data.length)
          })
          resolve();
        }
      })
    })
    
  }

  cancel= () => {
    this.props.cancelDialog('orderDialog');
  }
  getMessageData = (type,page) => {
    app.showLoading({
      title: '加载中..',
    })
    let that = this
    let action = ''
    let status = null
    if (type == '1') {
      action = '8'
      status = 1
    } else if (type = '2') {
      action = '17'
      status = 6
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/orderList',
      method: 'POST',
      data: {
        goods_type: action,
        page: page || 1,
        page_size: 4,
        screening_cond: {
          status: status
        }
      },
      success: function (res) {
        app.hideLoading();
        that.setState({
          list: res.data,
          isMore: res.is_more,
          currentPage: res.current_page || '1',
        })
      }
    })
  }
  checkTap = event => {
    let type = event.currentTarget.dataset.type;
    this.setState({
      tabStatus: type,
      list: [],
    })
    this.getMessageData(type);
  }
  nextPage = () => {
    if(this.state.isMore != 1){
      Toast.info('已经是最后一页了')
      return
    }
    let page = this.state.currentPage + 1;
    this.getMessageData(this.state.tabStatus,page);
    
  }
  prePage = () => {
    if(this.state.currentPage == 1){
      Toast.info('已经是第一页了')
      return
    }
    let page = this.state.currentPage > 2 ? this.state.currentPage - 1:1
    this.getMessageData(this.state.tabStatus,page);
  }
  render() {
    let orderStatusName = {
      8: ['待付款', '已付款', '', '', '', '', '', '已关闭'], //会员卡
      17: ['待付款', '已付款', '', '', '', '', '已完成', '已关闭'], //积分
    }
    let { isNeedVip, isNeedIntegral } = this.state;
    return (
      <div className='orderListDialog'>
        <div className='mask' onClick={this.cancel}></div>
        <div className='content'>
          <label className='ico-moon icon-closes closes_btn' onClick={this.cancel}></label>
          <div className='title'>订单记录</div>
          <div className='tab_line'>
            {isNeedVip == true && <div className={this.state.tabStatus=='1'?'active':''} onClick={this.checkTap} data-type='1'>会员卡订单</div>}
            {isNeedIntegral == true && <div className={this.state.tabStatus=='2'?'active':''} onClick={this.checkTap} data-type='2'>积分充值订单</div>}
          </div>
          <div className='main'>
            <div className='tabel_head'>
              <div>订单号</div>
              <div>商品名称</div>
              <div>商品价格</div>
              <div>订单状态</div>
              <div>创建时间</div>
            </div>
            {this.state.list.map((item,index) =>
              <div className='tabel_item' key={index}>
                <div>{item.form_data.order_id}</div>
                <div>{this.state.tabStatus=='1'?item.form_data.goods_info.goods_name:item.form_data.chat_ai && item.form_data.chat_ai.chat_send_nums + '积分/' + item.form_data.chat_ai.chat_price + '元'}</div>
                <div>￥{item.form_data.total_price}</div>
                <div>{orderStatusName[item.form_data.goods_type][item.form_data.status]}</div>
                <div>{item.form_data.add_time}</div>
              </div>
            )}
            {this.state.list.length == 0 && 
              <div className='no_data'>
                <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/undata.png" />
                <div>暂无数据~</div>
              </div>
            }
          </div>
          <div className='bottom_line'>
            <div className={'underline ' + (this.state.list.length != 0?'':'w_808')}></div>
            {this.state.list.length != 0 &&
              <div className='btn_box'>
                <label className='ico-moon icon-leftarrow' onClick={this.prePage}></label>
                <div className='btn_page'>{this.state.currentPage}</div>
                <label className='ico-moon icon-rightarrow' onClick={this.nextPage}></label>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/chatgpt-page/component/OrderList/OrderList.jsx